import { dictionary as dictionary_en } from './en/index.js';
import { dictionary as dictionary_ca } from './ca/index.js';
import { dictionary as dictionary_de } from './de/index.js';
import { dictionary as dictionary_es } from './es/index.js';
import { dictionary as dictionary_fr } from './fr/index.js';
import { dictionary as dictionary_it } from './it/index.js';
import { dictionary as dictionary_nl } from './nl/index.js';
import { dictionary as dictionary_pt } from './pt/index.js';
import { addToDictionary } from '../../../../i18n/index.js';
const dictionaries = {
    en: dictionary_en,
    ca: dictionary_ca,
    de: dictionary_de,
    es: dictionary_es,
    fr: dictionary_fr,
    it: dictionary_it,
    nl: dictionary_nl,
    pt: dictionary_pt,
};
Object.entries(dictionaries).forEach(entry => {
    const dictionary = addToDictionary(entry[0], entry[1]);
});
